export default __webpack_public_path__ + "static/media/Snd2.3b35f322.mp3";